var styles = {"box":"SecurityCard_box_1j07k_1","lightTextColor":"SecurityCard_lightTextColor_1j07k_21","small-btn":"SecurityCard_small-btn_1j07k_27","title":"SecurityCard_title_1j07k_35","text":"SecurityCard_text_1j07k_48","verified":"SecurityCard_verified_1j07k_58","row":"SecurityCard_row_1j07k_72","timer":"SecurityCard_timer_1j07k_79","divider":"SecurityCard_divider_1j07k_91"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
